import type { GridTableContentSection } from 'components/GridTable/types'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TBlockId, TPropertyId } from 'stores/fieldAssetStore/helperTypes'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'

export const blockLacksCropSectionMaker = ({
  id,
  propertyId = Number(selectedFieldAssetsStore.getState().property),
  blockId = Number(selectedFieldAssetsStore.getState().block),
  title,
  translatedCropName,
  titleToggle,
  titleLink,
  fieldAssetPicker,
}: {
  id: StackedChartSection['id'] & GridTableContentSection['id']
  propertyId?: TPropertyId
  blockId?: TBlockId
  translatedCropName: string
  title: StackedChartSection['title'] & GridTableContentSection['title']
  titleToggle?: StackedChartSection['titleToggle'] & GridTableContentSection['titleToggle']
  titleLink?: StackedChartSection['titleLink'] & GridTableContentSection['titleLink']
  fieldAssetPicker: StackedChartSection['fieldAssetPicker'] & GridTableContentSection['fieldAssetPicker']
}): StackedChartSection & GridTableContentSection => {
  const blockName =
    fieldAssetStore.getState()?.properties?.[propertyId]?.blocks?.[blockId]?.name ??
    translate.phrases.banyanApp('Unknown Block')

  return {
    id,
    title,
    titleToggle,
    titleLink,
    items: [],
    fieldAssetPicker,
    fullWidthItems: [
      {
        height: 150,
        content: (
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {translate.phrases.banyanApp('Block ({{blockName}}) does not have {{cropName}}.', {
              blockName,
              cropName: translatedCropName,
            })}
          </div>
        ),
      },
    ],
    defaultCollapsed: false,
  }
}
